import { render, staticRenderFns } from "./parallax-el.vue?vue&type=template&id=6ad56df9&scoped=true&"
import script from "./parallax-el.vue?vue&type=script&lang=js&"
export * from "./parallax-el.vue?vue&type=script&lang=js&"
import style0 from "./parallax-el.vue?vue&type=style&index=0&id=6ad56df9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad56df9",
  null
  
)

export default component.exports